import styles from "./EmptyState.module.css";

export function EmptyState({ icon = "🐝", title, description, action }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.icon} aria-hidden="true">{icon}</div>
      <h3 className={styles.title}>{title}</h3>
      {description && <p className={styles.description}>{description}</p>}
      {action}
    </div>
  );
}
